import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import React from "react";
import { useToast } from "@/providers";
import { GenericDeleteDialogProps } from "./types";

export function GenericDeleteDialog({
  visible,
  onClose,
  onDelete,
  texts,
}: GenericDeleteDialogProps) {
  const { showToast } = useToast();

  const handleDelete = async () => {
    onClose();
    try {
      await onDelete();
      showToast({
        severity: "success",
        summary: "SUCCESS",
        detail: texts.success,
        life: 3000,
      });
    } catch {
      showToast({
        severity: "error",
        summary: "ERROR",
        detail: texts.error,
        life: 3000,
      });
    }
  };

  return (
    <Dialog
      header={texts.header}
      visible={visible}
      style={{ width: "25rem" }}
      footer={
        <div className="flex justify-content-end gap-2">
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text"
            onClick={onClose}
          />
          <Button
            severity="danger"
            label="Delete"
            icon="pi pi-trash"
            onClick={handleDelete}
            autoFocus
          />
        </div>
      }
      onHide={onClose}
      maximizable
    >
      <div className="flex flex-column align-items-center">
        <p>{texts.warning}</p>
      </div>
    </Dialog>
  );
}
